import { render, staticRenderFns } from "./BranchesV2.vue?vue&type=template&id=452377b4&"
import script from "./BranchesV2.vue?vue&type=script&lang=js&"
export * from "./BranchesV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/zp_frontend_vuejs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('452377b4')) {
      api.createRecord('452377b4', component.options)
    } else {
      api.reload('452377b4', component.options)
    }
    module.hot.accept("./BranchesV2.vue?vue&type=template&id=452377b4&", function () {
      api.rerender('452377b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/BranchesV2.vue"
export default component.exports